<template>
  <section class="value-section section-b-space">
    <div class="container">
      <div class="trending-blog">
        <div class="blog-title">
          <h2> {{ _T(heading) }}</h2>
        </div>
      </div>
      <div class="help-card">
          <b-row align-v="center"  v-for="(chunked, indexC) in chunk(blocks, 3)"
          :key="indexC">
            <b-col
              v-for="(block, index) in chunked"
              :key="index"
              sm="12"
              md="4"
            >
              <div class="default-card">
                <div class="body-default">
                  <img
                    :src="block.card_image || '/images/svg/global/star.svg'"
                    :alt="_T_DB(block, 'heading')"
                    class="card-img"
                  />
                  <h3>{{ _T_DB(block, 'heading') }}</h3>
                  <h6>
                    {{ _T_DB(block, 'text') }}
                  </h6>
                </div>
              </div>
            </b-col>
          </b-row>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { chunk } from '@/utils/main_utils'
export default {
  name: 'ValuesPart',
  props: {
    blocks: {
      type: Array,
      default() {
        return []
      },
    },
    heading: {
      type: String,
      default() {
        return 'Our Values'
      },
    },
  },
  data: () => ({
    chunk: chunk
  }),
  computed: {
    ...mapGetters(['_T', '_T_DB']),
  }
}
</script>

<style lang="scss" scoped>
.value-section {
  background-color: rgba(237, 239, 244, 0.2);
  .help-card {
    margin-top: 0;
  }
}
.help-card {
  padding-top: 0;
  margin-top: -$px80;
  .default-card {
    background-color: $white;
    overflow: hidden;
    transition: all 0.5s ease;
    .body-default {
      h3 {
        margin-top: calc(
          #{$px15} + (30 - 15) * ((100vw - #{$px320}) / (1920 - 320))
        ) !important;
      }
    }
    .body-default,
    .footer-default {
      text-align: center;
      transition: all 0.5s ease;
      img {
        margin-top: -$px6;
      }
      h3 {
        font-weight: 600;
        margin-top: calc(
          #{$px5} + (18 - 5) * ((100vw - #{$px320}) / (1920 - 320))
        );
      }
      h6 {
        margin-bottom: -$px2;
      }
      a {
        color: $warning-color;
        font-weight: 600;
      }
      .card-img {
        max-height: 60px;
        max-width: 60px;
      }
    }
    &:hover {
      transform: translateY(-6px);
      transition: all 0.5s ease;
      .footer-default {
        background-color: $warning-color;
        transition: all 0.5s ease;
        a {
          color: $black;
          transition: all 0.5s ease;
        }
      }
    }
    
  }
  .row:not(:first-of-type) {
    margin-top: 30px;
  }
}
.default-card {
  box-shadow: 0 $px10 $px24 rgba(0, 0, 0, 0.08);
  border-radius: $px10;
  .body-default {
    padding: calc(#{$px16} + (30 - 16) * ((100vw - #{$px320}) / (1920 - 320)));
  }
  .footer-default {
    border-top: $px1 solid $light-border;
    padding: calc(#{$px10} + (15 - 10) * ((100vw - #{$px320}) / (1920 - 320)));
  }
}
@media (max-width: 991px) {
  .value-section {
    .help-card {
      .row {
        div.col-sm-12.col-md-4 {
          margin-top: 0px;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .value-section {
    .help-card {
      padding-top: 0;
      .row {
         div.col-sm-12.col-md-4 {
          margin-top: 20px;
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .value-section {
    .help-card {
      .row {
         div.col-sm-12.col-md-4 {
          margin-top: 30px;
        }
      }
    }
  }
}
</style>
